/*A collection of user objects*/
import Tariff from "@/types/Tariff/Tariff";
class TariffList {
    tariffs = []; // the collection of teams.
    constructor(jsonData) {
        if (jsonData !== null) {
            try {
                jsonData.forEach((tariff) => {
                    this.tariffs.push(new Tariff(tariff)); //adds a new team to the array
                });
            }
            catch (err) {
                window.errorHandler.logError(err, 'Types/TariffList -> constructur');
            }
        }
    }
    //returns the tariff with the given ID or null
    getTariffFromId(id) {
        if (this.tariffs.length > 0) {
            const returnTariff = this.tariffs.filter((object) => (object.id === id));
            return returnTariff[0];
        }
    }
}
export default TariffList;
